/* Copyright 2013 - 2024 Waiterio LLC */
/** @jsxImportSource @emotion/react */
import React from 'react'
import dNone from '@waiterio/styles/bootstrap/dNone.js'
import dLgBlock from '@waiterio/styles/bootstrap/dLgBlock.js'
import dLgNone from '@waiterio/styles/bootstrap/dLgNone.js'
import NavigationDesktopComponent from './NavigationDesktopComponent.jsx'
import NavigationSmartphoneComponent from './NavigationSmartphoneComponent.jsx'

const NavigationComponent = ({ locale }) => (
  <>
    <div css={dLgNone}>
      <NavigationSmartphoneComponent locale={locale} />
    </div>
    <div css={[dNone, dLgBlock]}>
      <NavigationDesktopComponent locale={locale} />
    </div>
  </>
)

export default NavigationComponent
